// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { ActionType } from 'typesafe-actions';

import { createFavoritesActions } from './actionCreators/createFavoritesActions';
import { deleteFavoritesActions } from './actionCreators/deleteFavoritesActions';
import { getCartActions } from './actionCreators/getCartActions';
import { getLabInformationActions } from './actionCreators/getLabInformationActions';
import { getChallengeInformationActions } from './actionCreators/getChallengeInformationActions';
import { getExamInformationActions } from './actionCreators/getExamInformationActions';
import { getLabRelatedActions } from './actionCreators/getLabRelatedActions';
import { getChallengeRelatedActions } from './actionCreators/getChallengeRelatedActions';
import { getLabReviewsActions } from './actionCreators/getLabReviewsActions';
import { getChallengeReviewsActions } from './actionCreators/getChallengeReviewsActions';
import { buyLabActions } from './actionCreators/buyLabActions';
import { buyChallengeActions } from './actionCreators/buyChallengeActions';
import { buyExamActions } from './actionCreators/buyExamActions';
import { endLabActions } from './actionCreators/endLabActions';
import { endChallengeActions } from './actionCreators/endChallengeActions';
import { endExamActions } from './actionCreators/endExamActions';
import { addOnlineCourseToCartActions } from './actionCreators/addOnlineCourseToCartActions';
import { removeOnlineCourseFromCartActions } from './actionCreators/removeOnlineCourseFromCartActions';
import { getOnlineCourseFeedbackActions } from './actionCreators/getOnlineCourseFeedbackActions';
import { getOnlineCourseRelatedActions } from './actionCreators/getOnlineCourseRelatedActions';
import { getVodListActions } from './actionCreators/getVodListActions';
import { postCreateCouponActions } from './actionCreators/postCreateCouponActions';
import { postOnlineCourseChaptersProgressActions } from './actionCreators/postOnlineCourseChaptersProgressActions'
import { postOnlineCourseFeedbackActions } from './actionCreators/postOnlineCourseFeedbackActions';
import { postLabReviewsActions } from './actionCreators/postLabReviewsActions';
import { postChallengeReviewsActions } from './actionCreators/postChallengeReviewsActions';
import { postJoinOrganizationActions } from './actionCreators/postJoinOrganizationActions'
import { updateViewHistoryActions } from './actionCreators/updateViewHistoryActions';
import { sendActiveActions } from './actionCreators/sendActiveActions';
import sendVisitedLabActions from './actionCreators/sendVisitedLabActions';
import sendVisitedChallengeActions from './actionCreators/sendVisitedChallengeActions';
import { updateRunningLabAction, clearRunningLabAction } from './actionCreators/runningLabAction';
import { updateRunningChallengeAction, clearRunningChallengeAction } from './actionCreators/runningChallengeAction';
import { updateRunningExamAction, clearRunningExamAction } from './actionCreators/runningExamAction';
import { updateFooterVisibleHeight } from './actionCreators/mainLayoutActions';
import home from './actionCreators/home';
import notifications from './actionCreators/notifications';
import onlineCourse from './actionCreators/onlineCourse';
import iltCourse from './actionCreators/iltCourse';
import support from './actionCreators/support';
import search from './actionCreators/search';
import workshop from './actionCreators/workshop';
// import all actions to build a action map for ts check in epics / reducers
export const actionCreatorsList = {
  ...home,
  ...notifications,
  ...onlineCourse,
  ...search,
  ...workshop,
  ...support,
  ...iltCourse,
  sendActiveActions,
  addOnlineCourseToCartActions,
  removeOnlineCourseFromCartActions,
  createFavoritesActions,
  deleteFavoritesActions,
  getOnlineCourseFeedbackActions,
  postOnlineCourseFeedbackActions,
  getOnlineCourseRelatedActions,
  updateViewHistoryActions,
  getVodListActions,
  getCartActions,
  getLabInformationActions,
  getChallengeInformationActions,
  getExamInformationActions,
  getLabReviewsActions,
  getChallengeReviewsActions,
  getLabRelatedActions,
  getChallengeRelatedActions,
  postOnlineCourseChaptersProgressActions,
  postLabReviewsActions,
  postChallengeReviewsActions,
  buyLabActions,
  buyChallengeActions,
  buyExamActions,
  postCreateCouponActions,
  postJoinOrganizationActions,
  endLabActions,
  endChallengeActions,
  endExamActions,
  sendVisitedLabActions,
  sendVisitedChallengeActions,
  updateRunningLabAction,
  updateRunningChallengeAction,
  updateRunningExamAction,
  clearRunningLabAction,
  clearRunningChallengeAction,
  clearRunningExamAction,
  updateFooterVisibleHeight,
};

export type RootAction = ActionType<typeof actionCreatorsList>;
